
<div class="container">
<h3 class="mt-3">We've Updated Our Sign-In System</h3>
<p>To provide you with a more secure, reliable, and seamless experience, we've upgraded our sign-in system. This update makes it easier to manage your account and ensures stronger protection for your personal information. </p>
<p>As part of this change, all users are required to reset their passwords. The process is quick and straightforward, and once complete you'll enjoy: </p>
<ul>
    <li>Improved security to help keep your account safe</li>
    <li>Simplified login with a smoother sign-in experience</li>
    <li>Greater reliability backed by trusted, enterprise-level technology</li>
</ul>
<p>Please reset your password now to continue accessing your account by following the steps below:</p>
<ol>
    <li>Click the Sign Up/ Sign In link on the top of the navigation bar</li>
    <li>Select <i>Reset your Password</i></li>
    <li>Enter your email and click <i>Send verification code</i></li>
    <li>Check for an email from <i>system&#64;outdooraccess.com</i> with your generated code. (Check your junk email folder if you don't see it in your Inbox.)</li>
    <li>Enter that on the next screen and click <i>Verify code</i>. (Code will time out after 5 minutes. You can request another code if needed.)</li>
    <li>Once verified, click <i>Continue</i></li>
    <li>Enter your new password twice and click <i>Continue</i></li>
    <li>Once complete, you'll be signed in automatically and ready to go. This is a one-time reset, and you won't need to do it again.</li>
</ol>
</div>
